
export const state = {
    cart: []
}
export const mutations = {
    ADDITEMTOCART(state, crendentials){
        if(state.cart.length > 0){
            
            for(let x = 0; x < state.cart.length; x++){
                if(state.cart[x].product.name == crendentials.product.name){
                    state.cart[x].quantity+= crendentials.quantity;
                    console.log(state.cart);
                    state.cart[x].amount += (crendentials.quantity * crendentials.amount)
                    localStorage.setItem('CART_ITEMS', JSON.stringify(state.cart));
                    return ''
                }
            }
            state.cart.push(crendentials)
        }else{
            state.cart.push(crendentials)
        }
        
        localStorage.setItem('CART_ITEMS', JSON.stringify(state.cart));
    },

    INCREASECARTQTY(state, idx){
        state.cart[idx].quantity++;

        let productPrice = state.cart[idx].product.price;
        let  productQty = state.cart[idx].quantity;

        state.cart[idx].amount =  sumUp(productPrice, productQty)

        function sumUp (a, b){
            return Number(a * b)
        }

        localStorage.setItem('CART_ITEMS', JSON.stringify(state.cart));
    },

    DECREASECARTQTY(state, idx){
        state.cart[idx].quantity--;
        let productPrice = state.cart[idx].product.price;
        let  productQty = state.cart[idx].quantity;

        state.cart[idx].amount =  sumUp(productPrice, productQty)

        function sumUp (a, b){
            return Number(a * b)
        }
        localStorage.setItem('CART_ITEMS', JSON.stringify(state.cart));
    },

    PENDINGCARTITEM(state, crendentials){
        state.cart = crendentials;
    },
    DELETEITEM(state, idx){
        state.cart.splice(idx, 1)
    },

    EMPTYCARTITEM(state){
        state.cart = [],
        localStorage.removeItem('CART_ITEMS');
    }

}

export const actions ={
    addItemToCart({commit}, crendentials){
        commit('ADDITEMTOCART', crendentials)
    },
    increaseQty({commit}, idx){
        commit('INCREASECARTQTY', idx)
    },
    reduceQty({commit}, idx){
        commit('DECREASECARTQTY', idx)
    },
    unclearedCart({commit}, crendentials){
        commit('PENDINGCARTITEM', crendentials)
    },
    removeItem({commit}, idx){
        commit('DELETEITEM', idx)
    },

    clearCart({commit}){
        commit('EMPTYCARTITEM')
    }
}

export const getters ={
    CartItems: state =>{
        return state.cart
    }
}